import { ComponentRegistry } from '@sg-core/resources/assets/js/utils';

export class IwcComponentRegistry extends ComponentRegistry {
  protected getModules(): Record<string, () => Promise<unknown>> {
    return import.meta.glob('/modules/SG/maisons/iwc/src/View/Components/**/*.ts');
  }
}
